<template>
    <v-container class="fill-height align-start" >
        <v-col>
            <v-row>
                <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                    <v-card
                        rel="week-statistics"
                        :subtitle="subtitleWeek"
                        :title="titleWeek"
                    >
                        <template v-slot:prepend>
                            <v-avatar color="red-darken-1" v-if="this.differenceWeek < 0">
                                <v-icon icon="mdi-arrow-down"></v-icon>
                            </v-avatar>
                            <v-avatar color="green-darken-1" v-if="this.differenceWeek > 0">
                                <v-icon icon="mdi-arrow-up"></v-icon>
                            </v-avatar>
                        </template>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                    <v-card
                            rel="month-statistics"
                            :subtitle="subtitleMonth"
                            :title="titleMonth"
                        >
                        <template v-slot:prepend>
                            <v-avatar color="red-darken-1" v-if="this.differenceMonth < 0">
                                <v-icon icon="mdi-arrow-down"></v-icon>
                            </v-avatar>
                            <v-avatar color="green-darken-1" v-if="this.differenceMonth > 0">
                                <v-icon icon="mdi-arrow-up"></v-icon>
                            </v-avatar>
                        </template>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                    <v-card
                            rel="project-statistic"
                            :subtitle="subtitleProject"
                            :title="titleProject"
                        >
                        <template v-slot:prepend>
                            <v-icon color="green-darken-3" icon="mdi-check-all"></v-icon>
                        </template>
                    </v-card>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12" md="8">
                    <v-card
                            rel="week-chart"
                            subtitle=""
                            title="Weekly statistics"
                        >
                        <template v-slot:prepend>
                            <v-icon color="blue-lighten-1" icon="mdi-chart-bar"></v-icon>
                        </template>
                        <v-card-text class="bg-surface pt-4">
                            <weekly-statistics-box v-model="chartDate"></weekly-statistics-box>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                    <v-card
                            rel="week-chart"
                            subtitle=""
                            title="Projects progress"
                        >
                        <template v-slot:prepend>
                            <v-icon color="blue-lighten-1" icon="mdi-progress-check"></v-icon>
                        </template>
                        <v-card-text class="bg-surface pt-4">
                            <v-list select-strategy="leaf" disabled>
                                <v-list-item
                                    v-for="item in projects"
                                    :key="item.projectId"
                                    
                                >
                                    <v-list-item-title v-text="item.code"></v-list-item-title>
                                    <v-list-item-subtitle class="border-b-thin" >
                                        {{ item.companyName }}
                                        <v-row >
                                            <v-col cols="12" class="pb-1">
                                                <v-progress-linear
                                                    v-model="item.percent"
                                                    color="purple"
                                                    height="15"
                                                    rounded="lg"
                                                ></v-progress-linear>
                                            </v-col>
                                            <v-col cols="12" class="pt-1">
                                                <div style="text-align: right; font-size: 0.7rem;" > {{ item.doneParts }}/ {{ item.totalParts }}</div>
                                            </v-col>
                                        </v-row>
                                    </v-list-item-subtitle>
                                </v-list-item>
                            </v-list>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-col>
    </v-container>
</template>


<script>

import StatisticApi from '../services/StatisticApi'
import WeeklyStatisticsBox from '@/components/WeeklyStatisticsBox.vue';

export default {
    name: 'HomePage',
    data() {
        return {
            week: 0,
            compareWeek: 0,
            month: 0,
            compareMonth: 0,
            currentMonthHours: 0,
            otherMonthHours: 0,
            differenceMonth: 0,
            currentWeekHours: 0,
            otherWeekHours: 0,
            differenceWeek: 0,
            completed: 0,
            inProgress: 0,
            chartDate: { start: null, end: null, startCompare: null, endCompare: null },
            days: [],
            projects: []
        }
    },
    components: {
        WeeklyStatisticsBox
    },
    methods: {
        weekOfYear(date) {
            const startOfYear = new Date(date.getFullYear(), 0, 1);
            var day = startOfYear.getDay();
            if(day == 0)
                day = 7;
            day = day - 1;
            if(day >= 1 && day <= 4) {
                // week 1
                startOfYear.setDate(startOfYear.getDate() - day);
            }
            else {
                // week 52/53
                startOfYear.setDate(startOfYear.getDate() + (7 - day));
            }
            return Math.ceil((date - startOfYear) / (7 * 24 * 3600 * 1000));
        },
        
        getFirstDayOfTheWeek(year, weekNumber) {
            let firstOfJan = new Date(year, 0, 1);
            
            let daysOffset = 4 - firstOfJan.getDay()
            firstOfJan.setDate(firstOfJan.getDate() + daysOffset);
            let firstThursdayOfYear = new Date(firstOfJan);
            let firstWeekOfYear = this.weekOfYear(firstOfJan);
            if (firstWeekOfYear == 1) {
                weekNumber -= 1;
            }
            firstThursdayOfYear.setDate(firstThursdayOfYear.getDate() + (weekNumber * 7 - 3));
            return new Date(firstThursdayOfYear);
        }
    },
    computed: {
        subtitleMonth () {
            if(this.differenceMonth > 0)
                return `up ${this.differenceMonth}% from ${this.otherMonthHours} h previous month`
            else if (this.differenceMonth < 0)
                return `down ${this.differenceMonth}% from ${this.otherMonthHours} h previous month`
            else 
                return `same as ${this.otherMonthHours} h previous month`
        },
        titleMonth () {
            return `${this.currentMonthHours} h last month`
        },
        subtitleWeek () {
            if(this.differenceWeek > 0)
                return `up ${this.differenceWeek}% from ${this.otherWeekHours} h previous week`
            else if (this.differenceWeek < 0)
                return `down ${this.differenceWeek}% from ${this.otherWeekHours} h previous week`
            else 
                return `same as ${this.otherWeekHours} h previous week`
        },
        titleWeek () {
            return `${this.currentWeekHours} h last week`
        },
        titleProject () {
            return `${this.completed} projects completed this week`
        },
        subtitleProject () {
            return `from ${this.inProgress} projects in progress`
        }
    },
    mounted() {
        let now  = new Date();
        let crtWeek = this.weekOfYear(now);
        this.week = crtWeek-1;
        this.compareWeek = crtWeek-2;
        this.month = now.getMonth();
        this.compareMonth = this.month-1;

        StatisticApi.comapreWeek({ 
            week: this.week,
            compareWeek: this.compareWeek
        }).then((response) => {
            if (response && response.data) {
                this.currentWeekHours = response.data.currentWeekHours
                this.otherWeekHours = response.data.otherWeekHours
                this.differenceWeek = response.data.difference
            }
        }).catch((e) => {
            this.message = e.message;
            this.snackbar = true;
        });

        StatisticApi.comapreMonth({ 
            month: this.month,
            compareMonth: this.compareMonth
        }).then((response) => {
            if (response && response.data) {
                this.currentMonthHours = response.data.currentMonthHours
                this.otherMonthHours = response.data.otherMonthHours
                this.differenceMonth = response.data.difference
            }
        }).catch((e) => {
            this.message = e.message;
            this.snackbar = true;
        });

        StatisticApi.getProjectStats()
        .then((response) => {
            if (response && response.data) {
                this.completed = response.data.completed;
                this.inProgress = response.data.inProgress;
                var p = response.data.projects;
                this.projects = [];
                for(var i in p) {
                    if(p[i].doneParts > p[i].totalParts)
                        continue;
                    this.projects.push(p[i]);
                }
            }
        }).catch((e) => {
            this.message = e.message;
            this.snackbar = true;
        });

        let start = this.getFirstDayOfTheWeek((new Date().getFullYear()), this.week + 1)
        let end = new Date(start);
        end.setDate(end.getDate() + 6)
        end = new Date(end);

        let startCompare = this.getFirstDayOfTheWeek((new Date().getFullYear()), this.compareWeek + 1)
        let endCompare = new Date(startCompare);
        endCompare.setDate(endCompare.getDate() + 6)
        endCompare = new Date(endCompare);

        this.chartDate = { start: start, end: end, startCompare: startCompare, endCompare: endCompare }
    }
}
</script>